module.exports = __webpack_public_path__ + "media/images/world-map2-6bbfbaf2c9caf7b154b2b861224d0016.svg";